module.exports = __webpack_public_path__ + "img/SubmitDialog.de465d0c.png";